module.exports = __webpack_public_path__ + "media/pop-7.f39d9c47.mp3";